module.exports = __webpack_public_path__ + "static/media/alicante-16.885074ec.jpg";